import { render } from "./MobileBar.vue?vue&type=template&id=70d47aa6&scoped=true"
import script from "./MobileBar.vue?vue&type=script&lang=js"
export * from "./MobileBar.vue?vue&type=script&lang=js"

import "./MobileBar.vue?vue&type=style&index=0&id=70d47aa6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d47aa6"]])

export default __exports__